import React, { useState, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import { logoEli, bgLogin03 } from "../../assets/";
import "./main.css";
import "./util.css";
import { useHistory } from "react-router-dom";
import axios from "../../lib/axios";
import errorHandler from "../../helpers/errorHandler";
import { MySwal } from "../../lib/swal";
import Modal from "react-bootstrap/Modal";
import { useLocation } from "react-router-dom";

const Login = () => {
  const location = useLocation();
  const history = useHistory();
  const [emailForgotPassword, setEmailForgotPassword] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const handleRegister = () => {
    history.push("registration");
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (email.length > 0 && password.length > 0) {
      const requestBody = {
        email: email,
        password: password,
      };

      axios({
        url: "/users/users/login",
        method: "POST",
        data: requestBody,
      })
        .then((res) => {
          if (res.data.code === "200") {
            // console.log(res.data.data.token)
            localStorage.setItem("access_token", res.data.data.token);
            history.push("/");
          }
        })
        .catch((err) => {
          if (err !== "") {
            console.log(err?.response?.data?.errors);
            // errorHandler({ err: err?.response?.data || err })
            MySwal.fire({
              icon: "warning",
              title: err?.response?.data?.status,
              text: err?.response?.data?.errors,
            });
          }
        });
    } else {
      MySwal.fire({
        icon: "warning",
        title: "Oops, Error!",
        text: "Email & Password tidak boleh kosong.",
      });
    }
  };

  const handleForgotPassword = () => {
    const requestBody = {
      email: emailForgotPassword,
    };

    axios({
      url: "/users/users/forgot-password",
      method: "POST",
      data: requestBody,
    })
      .then((res) => {
        if (res.data.code === "200") {
          MySwal.fire({
            icon: "success",
            title: "Success",
            text: "Link reset password sudah dikirim ke email terdaftar.",
          });
          setShowForgotPassword(false);
        }
      })
      .catch((err) => {
        if (err !== "") {
          console.log(err);
          errorHandler({ err: err?.response?.data || err });
        }
      });
  };

  useEffect(() => {
    window.dataLayer.push({
      event: "pageview",
      page: {
        url: window.location.pathname + window.location.search,
        title: document.title,
      },
    });
  }, [location]);

  if (localStorage.getItem("access_token")) {
    return (
      <div style={{ overflow: "hidden" }}>
        <div style={{ display: "flex" }}>
          <div style={{ marginLeft: "300px", marginTop: "100px" }}>
            <Redirect to="/" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="limiter">
      <div className="container-login100">
        <div className="wrap-login100">
          <form className="login100-form validate-form">
            <span style={{ fontFamily: "Montserrat" }}>
              <img
                style={{ margin: "auto" }}
                src={logoEli}
                alt="logoEli"
                className="login100-form-title p-b-17"
              />
              <div
                className="card"
                style={{ borderRadius: "20px", backgroundColor: "#FFFFFF" }}
              >
                <div className="card-body">
                  <h4 style={{ marginBottom: "6px" }}>Halo</h4>
                  <p style={{ fontWeight: "400" }}>
                    Selamat datang di website registrasi online prasmul-eli.
                    <br />
                    Silahkan login atau daftar jika belum memiliki akun.
                  </p>
                  <div className="col-12 mt-3">
                    <label className="form-label" htmlFor="Email">
                      Email
                    </label>
                    <input
                      id="Email"
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="name@example.com"
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                    />
                  </div>
                  <div className="col-12 mt-4">
                    <label className="form-label" htmlFor="Password">
                      Password
                    </label>
                    <input
                      id="Password"
                      type="password"
                      className="form-control form-control-solid"
                      placeholder="******"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                    />
                    <p
                      id="forgotPassword"
                      type="button"
                      className="mt-2"
                      onClick={() => setShowForgotPassword(true)}
                    >
                      Forgot Password
                    </p>
                  </div>
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      onClick={(e) => handleLogin(e)}
                      class="btn"
                      style={{
                        marginRight: "10px",
                        backgroundColor: "#26D07C",
                        color: "#F2F2F2",
                      }}
                    >
                      Login
                    </button>

                    <button
                      onClick={handleRegister}
                      class="btn btn-outline"
                      style={{ color: "#26D07C" }}
                    >
                      Pendaftaran
                    </button>
                  </div>
                </div>
              </div>
            </span>
            <div className="text-center p-t-46 p-b-20">
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "6px 18px",
                  marginBottom: "12px",
                }}
              >
                <Link
                  to="/kebijakan-pembatalan-refund"
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#0C86D9",
                    textDecoration: "none",
                    backgroundColor: "transparent",
                  }}
                >
                  Kebijakan Pembatalan &amp; Refund
                </Link>
                <Link
                  to="/kebijakan-privasi"
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#0C86D9",
                    textDecoration: "none",
                    backgroundColor: "transparent",
                  }}
                >
                  Kebijakan Privasi &amp; Perlindungan Data
                </Link>
              </div>
              <span>Copyright © 2026 | Online Registration</span>
              <br></br>
              <small style={{ fontSize: "10px" }}>Version: 3.19.1</small>
            </div>
          </form>
          <div
            className="login100-more"
            style={{ backgroundImage: "url(" + bgLogin03 + ")" }}
          ></div>
        </div>
      </div>

      <Modal
        show={showForgotPassword}
        size="md"
        onHide={() => setShowForgotPassword(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="ms-auto"
            style={{ margin: "auto", textAlign: "center" }}
          >
            <div className="mt-3 mb-3">
              <h2 className="mb-1">Forgot Password</h2>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#FFFFFF" }}>
          <div className="col-12">
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Enter your registered email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                onChange={(e) => setEmailForgotPassword(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <button
                className="btn"
                style={{
                  marginRight: "10px",
                  backgroundColor: "#26D07C",
                  color: "#F2F2F2",
                }}
                onClick={() => handleForgotPassword()}
              >
                Send
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Login;
